import React, { useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';

const TimedAlert = ({ message, duration, type }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
        }, duration);

        return () => clearTimeout(timer);
    }, [duration]);

    if (!visible) {
        return null;
    }

    return <Alert severity={type}>{message}</Alert>;
};

export default TimedAlert;